/**
 * Parses a hex color string (#RGB or #RRGGBB) into { r, g, b } (0–255).
 * Returns null if the string cannot be parsed.
 */
function parseHex(hex) {
	if (!hex || typeof hex !== 'string') return null;
	const clean = hex.replace(/^#/, '');
	if (clean.length === 3) {
		return {
			r: parseInt(clean[0] + clean[0], 16),
			g: parseInt(clean[1] + clean[1], 16),
			b: parseInt(clean[2] + clean[2], 16),
		};
	}
	if (clean.length === 6) {
		return {
			r: parseInt(clean.slice(0, 2), 16),
			g: parseInt(clean.slice(2, 4), 16),
			b: parseInt(clean.slice(4, 6), 16),
		};
	}
	return null;
}

/**
 * Converts a single sRGB channel (0–255) to its linear-light value.
 */
function toLinear(channel) {
	const c = channel / 255;
	return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}

/**
 * Returns the WCAG relative luminance of a hex color (0–1).
 */
function getLuminance(hex) {
	const rgb = parseHex(hex);
	if (!rgb) return 0;
	return 0.2126 * toLinear(rgb.r) + 0.7152 * toLinear(rgb.g) + 0.0722 * toLinear(rgb.b);
}

/**
 * Returns '#FFFFFF' or '#000000' — whichever has higher WCAG contrast
 * against the given background hex color.
 * Falls back to '#FFFFFF' when the color cannot be parsed.
 */
export function getContrastingTextColor(hex) {
	const bgLuminance = getLuminance(hex);
	const whiteLuminance = 1;
	const blackLuminance = 0;
	const contrastWithWhite = (whiteLuminance + 0.05) / (bgLuminance + 0.05);
	const contrastWithBlack = (bgLuminance + 0.05) / (blackLuminance + 0.05);
	return contrastWithWhite >= contrastWithBlack ? '#FFFFFF' : '#000000';
}

/**
 * Returns 'white--text' or 'black--text' (Vuetify helper classes) based on
 * which has higher WCAG contrast against the given background hex color.
 * Falls back to 'white--text' when the color cannot be parsed.
 */
export function getContrastingTextClass(hex) {
	return getContrastingTextColor(hex) === '#FFFFFF' ? 'white--text' : 'black--text';
}
